export const getNovaDefaultPromptsSuccess = (prompts) => ({
  type: "GET_NOVA_DEFAULT_PROMPTS_SUCCESS",
  payload: prompts,
});
export const createNovaConversationRequest = () => ({
  type: "CREATE_NOVA_CONVERSATION_REQUEST",
});

export const createNovaConversationSuccess = (conversation) => ({
  type: "CREATE_NOVA_CONVERSATION_SUCCESS",
  payload: conversation,
});

export const createNovaConversationFailure = (error) => ({
  type: "CREATE_NOVA_CONVERSATION_FAILURE",
  payload: error,
});

export const fetchNovaMessagesRequest = () => ({
  type: "FETCH_NOVA_MESSAGES_REQUEST",
});

export const fetchNovaMessagesSuccess = (
  messages,
  conversationId,
  append = false,
  hasMore = true,
  direction = "append"
) => ({
  type: "FETCH_NOVA_MESSAGES_SUCCESS",
  payload: {
    messages,
    conversationId,
    append,
    hasMore,
    direction,
  },
});

export const fetchNovaMessagesFailure = (error) => ({
  type: "FETCH_NOVA_MESSAGES_FAILURE",
  payload: error,
});

export const fetchAllNovaConversationsRequest = () => ({
  type: "FETCH_ALL_NOVA_CONVERSATIONS_REQUEST",
});

export const fetchAllNovaConversationsSuccess = (data) => ({
  type: "FETCH_ALL_NOVA_CONVERSATIONS_SUCCESS",
  payload: data,
});

export const fetchAllNovaConversationsFailure = (error) => ({
  type: "FETCH_ALL_NOVA_CONVERSATIONS_FAILURE",
  payload: error,
});

export const sendNovaChatMessageRequest = () => ({
  type: "SEND_NOVA_CHAT_MESSAGE_REQUEST",
});

export const sendNovaChatMessageSuccess = (conversationId, message) => ({
  type: "SEND_NOVA_CHAT_MESSAGE_SUCCESS",
  payload: { conversationId, message },
});

export const sendNovaChatMessageFailure = (error) => ({
  type: "SEND_NOVA_CHAT_MESSAGE_FAILURE",
  payload: error,
});

export const setUserMessageId = (id) => ({
  type: "SET_USER_MESSAGE_ID",
  payload: id,
});

export const setAIMessageId = (id) => ({
  type: "SET_AI_MESSAGE_ID",
  payload: id,
});

export const updateConversationTitleSuccess = (conversationId, title) => ({
  type: "UPDATE_CONVERSATION_TITLE_SUCCESS",
  payload: { conversationId, title },
});

export const setConversationMessages = (conversationId) => ({
  type: "SET_CONVERSATION_MESSAGES",
  payload: { conversationId },
});

export const clearConversationMessages = (conversationId) => ({
  type: "CLEAR_CONVERSATION_MESSAGES",
  payload: { conversationId },
});

export const regenerateNovaChatMessageRequest = () => ({
  type: "REGENERATE_NOVA_CHAT_MESSAGE_REQUEST",
});

export const regenerateNovaChatMessageSuccess = (conversationId, message) => ({
  type: "REGENERATE_NOVA_CHAT_MESSAGE_SUCCESS",
  payload: { conversationId, message },
});

export const regenerateNovaChatMessageFailure = (error) => ({
  type: "REGENERATE_NOVA_CHAT_MESSAGE_FAILURE",
  payload: error,
});

export const sendNovaChatFeedbackRequest = () => ({
  type: "SEND_NOVA_CHAT_FEEDBACK_REQUEST",
});

export const sendNovaChatFeedbackSuccess = (response) => ({
  type: "SEND_NOVA_CHAT_FEEDBACK_SUCCESS",
  payload: response,
});

export const sendNovaChatFeedbackFailure = (error) => ({
  type: "SEND_NOVA_CHAT_FEEDBACK_FAILURE",
  payload: error,
});

export const getUpdatedConversationRequest = () => ({
  type: "GET_UPDATED_NOVA_CONVERSATION_REQUEST",
});

export const getUpdatedConversationSuccess = (response) => ({
  type: "GET_UPDATED_NOVA_CONVERSATION_SUCCESS",
  payload: response,
});

export const getUpdatedConversationFailure = (error) => ({
  type: "GET_UPDATED_NOVA_CONVERSATION_FAILURE",
  payload: error,
});

export const setRegenerateAiResponse = (conversationId, response) => ({
  type: "SET_REGENERATE_AI_RESPONSE",
  payload: { conversationId, response },
});

export const setIsNovaChatBotOpen = (open) => ({
  type: "SET_IS_NOVA_CHATBOT_OPEN",
  payload: open,
});

export const setNewConversation = (isNewConvo) => ({
  type: "SET_NEW_CONVERSATION",
  payload: isNewConvo,
});

export const setIsGoalsAiEnabled = (isGoalsAiEnabled) => ({
  type: "SET_IS_GOALS_AI_ENABLED",
  payload: isGoalsAiEnabled,
});

export const setIsTeamsAiEnabled = (isTeamsAiEnabled) => ({
  type: "SET_IS_TEAMS_AI_ENABLED",
  payload: isTeamsAiEnabled,
});

export const setDisableHeaderOptions = (disableHeaderOptions) => ({
  type: "SET_DISABLE_HEADER_OPTIONS",
  payload: disableHeaderOptions,
});
export const setChangedConversation = (
  isConversationChanged,
  updatedConversationId,
  updatedConversationTitle
) => ({
  type: "SET_CHANGED_CONVERSTION",
  payload: {
    isConversationChanged,
    updatedConversationId,
    updatedConversationTitle,
  },
});

export const isNotFromImpersonateOrSwitchUser = (notFromOtherUser) => ({
  type: "IS_NOT_FROM_IMPERSONATE_OR_SWITCHUSER",
  payload: notFromOtherUser,
});

export const setConversationLoading = (conversationId, loading) => ({
  type: "SET_CONVERSATION_LOADING",
  payload: { conversationId, loading },
});

export const setConversationResponseLoading = (
  conversationId,
  responseLoading
) => ({
  type: "SET_CONVERSATION_CHAT_LOADING",
  payload: { conversationId, responseLoading },
});

export const resetNovaConversationState = () => ({
  type: "RESET_NOVA_CONVERSATION_STATE",
});

export const loadNovaConversation = (conversation) => ({
  type: "LOAD_NOVA_CONVERSATION",
  payload: conversation,
});

export const setNovaInitialPrompt = (prompt) => ({
  type: "SET_NOVA_INITIAL_PROMPT",
  payload: prompt,
});
